import React from "react";
import { Box, InputLabel, TextField, Button, Chip, IconButton } from "@mui/material";
import AirlineSeatReclineNormalOutlinedIcon from "@mui/icons-material/AirlineSeatReclineNormalOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import PaymentIcon from "@mui/icons-material/Payment";
import { useNavigate } from "react-router-dom";
import ProductoList from "./ProductoList";
import { useTheme } from "@mui/material/styles";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import SearchIcon from "@mui/icons-material/Search";
import PersonIcon from "@mui/icons-material/Person";
import fullImg from "../images/fullSinFondo.svg";
import tiendaImg from "../images/tienda.svg";
import NavigationTabs from "./NavigationTabs";

const FacturacionFlex = ({
  cliente,
  condicion,
  isScreenWidthLessThan600,
  handleSuspenderCTACTE,
  handleSuspenderRemito,
  handleGoToSaldos,
  isSuspenderRemitoEnabled,
  puestoActual,
  productos,
  handleDeleteRow,
  updateProducto,
  estadoDespacho,
  total,
  clientePercepciones,
  handleDeleteAll,
  handleFacturaElectronica,
  showFormasDePago,
  isPagosButtonDisabled,
  isEmitirFacturaEnabled,
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const habilitaTiendaFull = JSON.parse(localStorage.getItem("habilitaTiendaFull") || "false");
  const solicitarAforadores = JSON.parse(localStorage.getItem("solicitarAforadores") || "false");

  console.log("habilitaTiendaFull:", habilitaTiendaFull);
  console.log("solicitarAforadores:", solicitarAforadores);

  const buttonNavigationTabs = [
    ...(solicitarAforadores
      ? [
          {
            id: "despachos",
            icon: LocalGasStationIcon,
            label: "DESPACHOS",
            onClick: () => navigate("/despachossearchpage"),
          },
        ]
      : []),
    {
      id: "articulos",
      label: "ARTICULOS",
      icon: SearchIcon,
      onClick: () => navigate("/articulossearchpage"),
    },
    ...(habilitaTiendaFull
      ? [
          {
            id: "full",
            label: theme.bandera.labelTienda,
            image: theme.bandera.tiendaLogo,
            onClick: () => navigate("/tiendaPage/"),
          },
        ]
      : []),
    {
      id: "clientes",
      label: "CLIENTES",
      icon: PersonIcon,
      onClick: () => navigate("/clientessearchpage"),
    },
  ];

  console.log("buttonNavigationTabs:", buttonNavigationTabs);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        ml: 2,
        overflowX: "hidden",
        backgroundColor: "#f5f5f5",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: "100%", // aseguramos que el ancho se adapte al contenedor
          maxWidth: "480px", // tope ideal para clover
          px: 2,
          py: 2,
          backgroundColor: "white",
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        {" "}
        {/* BOTONES SUPERIORES */}
        <Box display="flex" justifyContent="center" mb={1}>
          <NavigationTabs
            items={buttonNavigationTabs}
            buttonStyle="navigation"
            isFull={habilitaTiendaFull}
            innerWidth={habilitaTiendaFull}
            isFacturacion
            itemsPerPage={3}
          />
          {/* <Box flex={1} mx={0.5}>
            <Button
              fullWidth
              variant="contained"
              sx={{
                borderRadius: 1,
                fontWeight: "bold",
                fontSize: 11,
                whiteSpace: "nowrap",
                backgroundColor: theme.bandera.colorSecundario,
                ":hover": {
                  backgroundColor: theme.bandera.colorSecundario,
                },
              }}
              onClick={() => navigate("/despachossearchpage")}
            >
              <LocalGasStationIcon sx={{ mr: 0.5, fontSize: 17 }} />
              DESPACHOS
            </Button>
          </Box>
          <Box flex={1}>
            <Button
              fullWidth
              variant="contained"
              sx={{
                borderRadius: 1,
                fontWeight: "bold",
                fontSize: 11,
                whiteSpace: "nowrap",
                backgroundColor: theme.bandera.colorSecundario,
                ":hover": {
                  backgroundColor: theme.bandera.colorSecundario,
                },
              }}
              onClick={() => navigate("/articulossearchpage")}
            >
              <SearchIcon sx={{ mr: 0.5, fontSize: 17 }} />
              ARTICULOS
            </Button>
          </Box>
          <Box flex={1} mx={0.5}>
            <Button
              fullWidth
              variant="contained"
              sx={{
                borderRadius: 1,
                fontWeight: "bold",
                fontSize: 11,
                whiteSpace: "nowrap",
                backgroundColor: theme.bandera.colorSecundario,
                ":hover": {
                  backgroundColor: theme.bandera.colorSecundario,
                },
              }}
              onClick={() => navigate("/clientessearchpage")}
            >
              <PersonIcon sx={{ mr: 0.5, fontSize: 17 }} />
              CLIENTES
            </Button>
          </Box> */}
        </Box>
        {/* DATOS DEL CLIENTE */}
        <Box display="flex" alignItems="center" mb={-1}>
          <InputLabel
            sx={{
              display: cliente && (cliente.emiteFacturayRemito || cliente.emiteRemito) ? "block" : "block",
              fontSize: "15px",
              mr: 0.5,
            }}
          >
            Cliente
          </InputLabel>
          <TextField
            value={cliente?.razonSocial || ""}
            size="small"
            disabled
            sx={{
              width: cliente && (cliente.emiteFacturayRemito || cliente.emiteRemito) ? "47%" : "73%",
              "& .MuiInputBase-root": {
                height: "30px",
                padding: 1,
                backgroundColor: "lightgrey",
              },
              "& .MuiInputBase-input": {
                fontSize: "0.800rem",
              },
              mr: 0.5,
            }}
            inputProps={{ style: { height: "30px", padding: 0 } }}
          />
          <IconButton
            sx={{
              display: "inline-flex",
              padding: "0.2rem",
              height: "auto",
              backgroundColor: theme.bandera.colorSecundario,
              borderRadius: "4px",
              color: "white",
            }}
            onClick={() => {
              navigate("/datoschofer");
            }}
          >
            <AirlineSeatReclineNormalOutlinedIcon />
          </IconButton>
          <Chip
            sx={{
              display: cliente && (cliente.emiteFacturayRemito || cliente.emiteRemito) ? "inline-flex" : "none",
              padding: "0.2rem",
              "& .MuiChip-label": {
                padding: 0,
                fontSize: "0.75rem",
              },
              height: "auto",
              margin: "0 3px",
            }}
            label="Emite Remito"
          />
        </Box>
        {/* CONDICIÓN + BOTONES */}
        <Box display="flex" alignItems="flex-start" justifyContent="space-between">
          {/* Condición */}
          <Box display="flex" alignItems="center" sx={{ mt: 1.5 }}>
            <InputLabel sx={{ mr: 0.5, fontSize: "15px" }}>Condición</InputLabel>
            <TextField
              value={condicion}
              size="small"
              disabled
              sx={{
                fontSize: "15px",
                backgroundColor: "lightgrey",
                width: 95,
                ".MuiInputBase-input": { fontSize: "0.800rem" },
                ".MuiInputBase-root": { height: "25px" },
              }}
            />
          </Box>

          {/* Botones Suspender */}
          {condicion !== "CONTADO" && (
            <Box display="flex" flexDirection="column" alignItems="flex-end" sx={{ mt: 1.5 }}>
              <Button
                variant="contained"
                sx={{
                  fontWeight: "bold",
                  backgroundColor: theme.bandera.colorSecundario,
                  ":hover": {
                    backgroundColor: theme.bandera.colorSecundario,
                  },
                  padding: "0.4rem",
                  fontSize: 11,
                  mb: 0.5,
                  whiteSpace: "nowrap",
                }}
                onClick={handleSuspenderCTACTE}
              >
                Suspender CTA. CTE.
              </Button>
              <Button
                variant="contained"
                sx={{
                  fontWeight: "bold",
                  backgroundColor: theme.bandera.colorSecundario,
                  ":hover": {
                    backgroundColor: theme.bandera.colorSecundario,
                  },
                  padding: "0.4rem",
                  fontSize: 11,
                }}
                disabled={!isSuspenderRemitoEnabled}
                onClick={handleSuspenderRemito}
              >
                Suspender Remito
              </Button>
              {condicion !== "CONTADO" && puestoActual?.verSaldoCliente && (
                <Button
                  onClick={handleGoToSaldos}
                  sx={{
                    backgroundColor: theme.bandera.colorSecundario,
                    color: "white",
                    position: "absolute",
                    right: "268px",
                    top: "174px",
                    whiteSpace: "nowrap",
                    fontWeight: "bold",
                    fontSize: 11,
                    ":hover": { backgroundColor: theme.bandera.colorSecundario },
                  }}
                >
                  Ver Saldo
                </Button>
              )}
            </Box>
          )}
        </Box>
        {/* LISTA DE PRODUCTOS */}
        <ProductoList
          productos={productos}
          handleDeleteRow={handleDeleteRow}
          updateProducto={updateProducto}
          estadoDespacho={estadoDespacho}
          isScreenWidthLessThan600={isScreenWidthLessThan600}
          isClienteRemito={cliente?.emiteRemito || cliente?.emiteFacturayRemito}
        />
        {/* TOTALES */}
        <Box display="flex" alignItems="center">
          <Button
            variant="contained"
            sx={{
              borderRadius: 1,
              fontWeight: "bold",
              fontSize: 9,
              lineHeight: 1,
              mr: 0.5,
              padding: 0.4,
              textAlign: "left",
              backgroundColor: theme.bandera.colorSecundario,
              ":hover": {
                backgroundColor: theme.bandera.colorSecundario,
              },
            }}
            onClick={handleDeleteAll}
          >
            <DeleteIcon />
            BORRAR TODO
          </Button>

          <Box display="flex" alignItems="center" mr={2}>
            <InputLabel sx={{ fontWeight: "bold", fontSize: "12px", mr: 0.5 }}>Perc</InputLabel>
            <TextField
              size="small"
              disabled
              value={`$${clientePercepciones}`}
              sx={{
                backgroundColor: "lightgrey",
                width: 85,
                ".MuiInputBase-input": { fontSize: "0.750rem" },
                ".MuiInputBase-root": { height: "30px" },
              }}
            />
          </Box>

          <Box display="flex" alignItems="center">
            <InputLabel sx={{ fontWeight: "bold", fontSize: "12px", mr: 0.5 }}>Total</InputLabel>
            <TextField
              size="small"
              disabled
              value={`$${total}`}
              sx={{
                backgroundColor: "lightgrey",
                width: 90,
                ".MuiInputBase-input": { fontSize: "0.750rem" },
                ".MuiInputBase-root": { height: "30px" },
              }}
            />
          </Box>
        </Box>
        {/* BOTONES FINALES */}
        <Box display="flex" justifyContent="center" mt={2}>
          <Box mr={2}>
            <Button
              variant="contained"
              onClick={handleFacturaElectronica}
              sx={{
                borderRadius: 2,
                fontWeight: "bold",
                backgroundColor: theme.bandera.colorSecundario,
                ":hover": { backgroundColor: theme.bandera.colorSecundario },
                fontSize: 14,
                width: 115,
                height: 100,
                flexDirection: "column",
              }}
              disabled={!isEmitirFacturaEnabled || (cliente && clientePercepciones === 0 && localStorage.getItem("percepciones") === "true")}
            >
              <PointOfSaleIcon sx={{ fontSize: 50 }} />
              CTA. CTE.
            </Button>
          </Box>
          <Box>
            <Button
              variant="contained"
              onClick={showFormasDePago}
              sx={{
                borderRadius: 2,
                fontWeight: "bold",
                backgroundColor: theme.bandera.colorSecundario,
                ":hover": { backgroundColor: theme.bandera.colorSecundario },
                fontSize: 14,
                width: 115,
                height: 100,
                flexDirection: "column",
              }}
              disabled={isPagosButtonDisabled || (cliente && clientePercepciones === 0 && localStorage.getItem("percepciones") === "true")}
            >
              <PaymentIcon sx={{ fontSize: 50 }} />
              PAGOS
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FacturacionFlex;
